export const GET_ADMIN_APPOINTMENT = 'GET_ADMIN_APPOINTMENT';
export const GET_APPOINTMENT_DATE = 'GET_APPOINTMENT_DATE';
export const SAVE_SINGLE_APPOINTMENT = 'SAVE_SINGLE_APPOINTMENT';
export const GET_BOOKED_APPOINTMENT = 'GET_BOOKED_APPOINTMENT';
